<template>
  <div
    v-if="isStore || lastVisitedStoreObject"
    ref="mystore"
    class="my-store"
  >
    <div
      v-if="isStore"
      class="wrap-container"
    >
      <a
        href="/"
        class="my-store__link"
        @click="trackStoreClick('/')"
      >
        <div class="my-store__prefix">Gå till ica.se</div>
      </a>
    </div>
    <div
      v-else-if="lastVisitedStoreObject"
      class="wrap-container"
    >
      <a
        :href="lastVisitedStoreObject.url"
        class="my-store__link"
        @click="trackStoreClick(lastVisitedStoreObject.url)"
      >
        <svgicon
          class="my-store__home-icon"
          name="Navigation/Home"
          role="presentation"
        />
        <span
          ref="storeName"
          :class="{ hasOverflow: storeNameOverflow }"
          class="my-store__store-name"
          v-text="lastVisitedStoreObject.name"
        />
      </a>
    </div>
  </div>
</template>
<script>
import ScrollObserver from '@/utils/scrollObserver'
import hideElementOnScroll from './hideElementOnScroll'
import ResizeObserver from '@/utils/resizeObserver'
import ga from '@/analytics/dataLayerTopNav.js'

export default {
  props: {
    isStore: {
      type: Boolean,
      default: false
    },
    storeName: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      storeNameOverflow: false,
      lastVisitedStoreObject: null
    }
  },
  beforeDestroy () {
    ScrollObserver.removeAllCallbacks(this.$refs.mystore)
    ResizeObserver.removeAllCallbacks(this)
  },
  mounted () {

      if (!SSR_MODE) {
        // same functionality as in EPI6
        let lastVisitedStore = localStorage.getItem('lastVisitedStore')
        if (lastVisitedStore) {
          this.lastVisitedStoreObject = JSON.parse(lastVisitedStore)
        }

        if (this.isStore) {
          this.setLastVisitedStoreLink(this.storeName)
        }

      }

      this.$nextTick(() => {
        if (!this.$refs.mystore || !this.lastVisitedStoreObject) {
          return
        }

        ScrollObserver.addCallback(this.$refs.mystore, hideElementOnScroll)

        if (!this.isStore) {
          ResizeObserver.addCallback(this, function () {
            this.storeNameOverflow = Math.round(this.$refs.storeName.offsetWidth - this.$refs.storeName.scrollWidth) < 0
          })
        }
      })
  },
  methods: {
    setLastVisitedStoreLink (name) {
    const url = location.href

    localStorage.setItem('lastVisitedStore', JSON.stringify({
      url, name
    }))

    },
    trackStoreClick (url) {
      ga.topNavStoreLink(url)
    }
  }
}
</script>

<style lang="scss">
.my-store {
  border-bottom: 1px solid $color-grey-special;
  background-color: $color-white;
  padding: 0.375rem 0 0.25rem;
  white-space: nowrap;
  z-index: 10;

  &__link {
    display: inline-block;
    text-decoration: none;

    @include font(text, 2, bold);
  }

  &__home-icon.svg-icon {
    width: 1.25rem;
    height: 1.25rem;
    margin-right: 0.25rem;
    display: none;
    fill: currentColor;
    transform: translateX(-14%);

    @include media-breakpoint-up(md) {
      display: inline;
    }
  }

  &__store-name {
    @include font(text, 2, bold);

    display: inline-block;
    margin-right: 0.5rem;
    position: relative;

    &.hasOverflow::before {
      content: "";
      display: block;
      position: absolute;
      width: 2rem;
      top: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(to left, $color-white 5%, rgba($color-white, 0) 100%);
    }
  }

  &__opening-text {
    display: none;

    @include media-breakpoint-up(md) {
      display: inline;
      vertical-align: top;
    }
  }
}
</style>
